import { produce } from 'immer';

import { ATTENDANT_COMPANIES_ACTION_TYPE } from '../actions';

const initialState = {
  companies: [],
  titleProviderCategoryId: null,
  escrowProviderCategoryId: null,
  attorneyProviderCategoryId: null,
};

const attendantCompaniesReducer = (state = initialState, { type, payload }) =>
  produce(state, () => {
    switch (type) {
      case ATTENDANT_COMPANIES_ACTION_TYPE.GET_ATTENDANT_COMPANIES_DATA:
        return payload || initialState;

      default:
        return state;
    }
  });

export default attendantCompaniesReducer;
